import getApiClient from '@/plugins/api-client'

export default {
  loadSettings () {
    const api = getApiClient(this.$store)

    api.get('settings')
      .then(result => {
        this.settings = result.data['hydra:member']
      })
      .catch(error => {
        this.error = error
      })
  },
}
